import type { Theme } from '@mui/material';
import styled from 'styled-components';

/* -------------------------------------------------------------------------- */

export const AppContainer = styled.div<{ theme: Theme }>`
  padding: 20px;
  font-family: ${({ theme }) => theme.typography.fontFamily};
`;

export const Toolbar = styled.div`
  margin: 10px 0;
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const MainLayout = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
`;

export const PdfViewer = styled.div<{ theme: Theme }>`
  position: relative;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  overflow: hidden;
  flex-shrink: 0;
  display: inline-block;
`;

export const Editor = styled.div<{ theme: Theme }>`
  width: 300px;
  max-height: 80vh;
  overflow-y: auto;
  padding-left: 20px;
  border-left: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const EditorItem = styled.div<{ theme: Theme }>`
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid;
  border-radius: 4px;
`;

export const EditorItemTextarea = styled.textarea`
  width: 100%;
  resize: vertical;
  min-height: 40px;
  padding: 5px;
  box-sizing: border-box;
`;

/* ================= Embedded Mode Styling ================= */

export const PdfEmbeddedContainer = styled.div<{ theme: Theme }>`
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;

  ${PdfViewer} {
    width: 100% !important;
    max-width: none !important;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    overflow: hidden;
  }

  ${Editor} {
    display: none !important;
  }

  ${Toolbar},
  input[type='file'] {
    display: none !important;
  }
`;

export const PdfEmbeddedLayout = styled.div`
  width: 100%;
  display: block !important;
  margin: 0;
  padding: 0;
`;

/* ================= Text Layer (for PDF.js) ================= */

export const TextLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 10;

  > span {
    pointer-events: auto;
    user-select: text;
    white-space: pre;
  }
`;
